import { render, staticRenderFns } from "./CourseByBuy.vue?vue&type=template&id=8357b76e&"
import script from "./CourseByBuy.vue?vue&type=script&lang=js&"
export * from "./CourseByBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports